/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "566")
  

// 接口文档

  
    
export interface IAPI77094ResComponentInstanceListItemBlockListItemPropertyListItemOptionListItem {
  
  /** 选项名称 */
  key?: string;
  
  /** 选项值 */
  value?: string;
  
};
    
  
    
export type IAPI77094ResComponentInstanceListItemBlockListItemPropertyListItemDataObj = {};
    
  
    
export interface IAPI77094ResComponentInstanceListItemBlockListItemPropertyListItem {
  
  /** 属性编码 */
  propertyCode?: string;
  
  /** 属性名称 */
  propertyName?: string;
  
  /** 属性类型 */
  propertyType?: string;
  
  /** 属性key */
  propertyKey?: string;
  
  /** 属性值 */
  propertyValue?: string;
  
  /** 选中值 */
  selectValue?: string;
  
  /** 选项范围 ,OptionResp */
  optionList?: IAPI77094ResComponentInstanceListItemBlockListItemPropertyListItemOptionListItem[];
  
  /** 专用参数 ,Object */
  data?: IAPI77094ResComponentInstanceListItemBlockListItemPropertyListItemDataObj;
  
};
    
  
    
export type IAPI77094ResComponentInstanceListItemBlockListItemDataObj = {};
    
  
    
export interface IAPI77094ResComponentInstanceListItemBlockListItem {
  
  /** 区块名称 */
  blockName?: string;
  
  /** 区块类型 */
  blockType?: string;
  
  /** 最少数量 */
  leastNum?: number;
  
  /** 最多数量 */
  mostNum?: number;
  
  /** 属性列表 ,AppPropertyResp */
  propertyList?: IAPI77094ResComponentInstanceListItemBlockListItemPropertyListItem[];
  
  /** 扩展block容器数据 ,Object */
  data?: IAPI77094ResComponentInstanceListItemBlockListItemDataObj;
  
};
    
  
    
export interface IAPI77094ResComponentInstanceListItem {
  
  /** 组件模板编码 */
  componentCode?: string;
  
  /** 坐标 */
  coordinate?: string;
  
  /** 组件模板名称 */
  componentName?: string;
  
  /** 组件分类 */
  componentClassify?: string;
  
  /** 组件类型 */
  componentType?: string;
  
  /** 区块列表 ,AppBlockResp */
  blockList?: IAPI77094ResComponentInstanceListItemBlockListItem[];
  
};
    
  
    
export interface IAPI77094ResPropertyLineListItem {
  
  /** 输出属性编码 */
  outPropertyCode?: string;
  
  /** 输出组件编码 */
  outComponentCode?: string;
  
  /** 输入属性编码 */
  inPropertyCode?: string;
  
  /** 输入组件编码 */
  inComponentCode?: string;
  
};
    
  
    
export interface IAPI77094ResResourcePermissionObjOrgsItem {
  
  /**  */
  orgId?: string;
  
  /**  */
  orgName?: string;
  
};
    
  
    
export interface IAPI77094ResResourcePermissionObjUsersItem {
  
  /**  */
  userId?: string;
  
  /**  */
  userName?: string;
  
};
    
  
    
export interface IAPI77094ResResourcePermissionObj {
  
  /** 部门ids ,String */
  deptIds?: string[];
  
  /** OrgResp */
  orgs?: IAPI77094ResResourcePermissionObjOrgsItem[];
  
  /** 用户ids ,String */
  userIds?: string[];
  
  /** UserResp */
  users?: IAPI77094ResResourcePermissionObjUsersItem[];
  
  /** 外部平台 ,String */
  platformCodeList?: string[];
  
  /** 权限类型 */
  permissionType?: string;
  
};
    
  



export interface API77094Req {
  
    appCode: string;
  
};



export interface API77094Res {
  /** 应用名称  */
  appName?: string;
  /** 应用code  */
  appCode?: string;
  /** 应用实例编码  */
  appInstanceCode?: string;
  /** 应用版本  */
  appVersion?: string;
  /** 实例状态  */
  appStatus?: number;
  /** 组件实例列表 ,AppComponentResp  */
  componentInstanceList?: IAPI77094ResComponentInstanceListItem[];
  /** 属性连线列表 ,AppPropertyLineResp  */
  propertyLineList?: IAPI77094ResPropertyLineListItem[];
  /** 资源权限 ,ResourcePermissionResp  */
  resourcePermission?: IAPI77094ResResourcePermissionObj;
  
};


// 接口函数 77094 查询应用实例详情

export interface IUseGetAPI77094Return {
  /** 查询应用实例详情: 接口请求状态 */
  isAPI77094Loading: boolean;
  /** 查询应用实例详情: 接口请求返回数据 */
  dataAPI77094: API77094Res;
  /**  查询应用实例详情: 接口数据请求方法 */
  fetchAPI77094Data: (inputs: API77094Req, config?: YWRequestConfig) => Promise<API77094Res>;
  /** 查询应用实例详情: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI77094 = ():IUseGetAPI77094Return => {
  let isMount = true;
  const [isAPI77094Loading, setIsAPI77094Loading] = useState(false);
  const [dataAPI77094, setDataAPI77094] = useState<API77094Res>({} as API77094Res);
  const requestUrl = `${basePath}/yoaichat-admin/app/instance/detail`;

  const fetchAPI77094Data = async (inputs: API77094Req, config?: YWRequestConfig): Promise<API77094Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77094Req>) || {}) as API77094Req;
    
  
    if ( isMount ) {
      setIsAPI77094Loading(true);
    }

    try {
      
      const res: any = await Request.get<API77094Res>(`${basePath}/yoaichat-admin/app/instance/detail/${parseParams<API77094Req>(params)}`, {
        loginHost: loginPath,
        ...config
      });
      
      if (isMount) {
        setDataAPI77094(res || {} as API77094Res);
        setIsAPI77094Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77094Loading(false);
      }
      return false as unknown as API77094Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77094Loading,
    dataAPI77094,
    fetchAPI77094Data,
    requestUrl,
  }
}

